import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";

export default function CategorySearch({ value, onChange, sx = {} }) {
  return (
    <MDBox
      sx={{
        width: "220px",
        minWidth: "160px",
        height: "34px",
        padding: "4px 10px",
        borderRadius: "10px",
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "grey.300",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        transition: "all 0.15s ease",
        mb: 0,
        "&:focus-within": {
          borderColor: "primary.main",
          boxShadow: (theme) => `0 0 0 3px ${alpha(theme.palette.primary.main, 0.18)}`,
        },
        ...sx, // permite override desde el padre
      }}
    >
      <Icon sx={{ fontSize: 18, color: "text.secondary", flexShrink: 0 }}>search</Icon>

      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Buscar categoría…"
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          fontSize: "0.80rem",
          background: "transparent",
        }}
      />
    </MDBox>
  );
}

CategorySearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
};
